import { SET_ORGANIZATIONS_DATA, REMOVE_ORGANIZATIONS, SET_ORGANIZATION_FILTER, SET_ORG_PAGE_NUMBER, SET_ALL_ORGANIZATION, SET_ORGANIZATION_COUNT } from '../types'

export const setOrganizationsData = (data) => ({
  type: SET_ORGANIZATIONS_DATA,
  payload: data,
})

export const setOrgSelectionCount = (count) => ({
  type: SET_ORGANIZATION_COUNT,
  payload: count,
})

export const removeOrganizations = () => ({
  type: REMOVE_ORGANIZATIONS,
})

export const setOrganizationFilter = (organizationId) => {
  return {
    type: SET_ORGANIZATION_FILTER,
    payload: organizationId,
  }
}

export const setOrganizationPageNumber = (pageNumber) => ({
  type: SET_ORG_PAGE_NUMBER,
  payload: pageNumber,
})

export const setAllOrganizationsData = (allOrganizations) => ({
  type: SET_ALL_ORGANIZATION,
  payload: allOrganizations,
})
